// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"Footer_Wrap__2B9JF","Nav":"Footer_Nav__B5ht4"};